import './App.css';
import { useState } from 'react';
import Nav from './components/Nav.js'
import AnimatedRoutes from './AnimatedRoutes';
import Mode from './components/Mode';
import {
  BrowserRouter as Router,
  NavLink
} from "react-router-dom";
function App() {
  const [theme, setTheme] = useState("Light");
  // useEffect(() => {

  // }, [])
  if (window.innerWidth < 700) {
    return (
      <p id='unsupported'>open on a computer pls</p>
    )
  }
  else {
    return (
      <Router>
        <Nav Link={NavLink} />
        <AnimatedRoutes theme={theme} setTheme={setTheme} />
        <Mode theme={theme} setTheme={setTheme} />
      </Router>
    );
  }
}

export default App;
